var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.297,
    height: 116.297,
    viewBox: "0 0 116.297 116.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a9400c1fc8fc3858a882e3f038df56b5",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M65.575.5H7.769A7.269,7.269,0,0,0,.5,7.769V109.528A7.269,7.269,0,0,0,7.769,116.8h76.4a7.269,7.269,0,0,0,7.269-7.269V26.369Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M7.769,52.9h76.4a7.269,7.269,0,0,0,7.269-7.269V32.4a3.261,3.261,0,0,0-.654-.131,3.35,3.35,0,0,0-3.344,3.362V41.8a2.8,2.8,0,0,1-3.082,2.8,2.635,2.635,0,0,1-2.8-2.653V31.1a3.5,3.5,0,0,0-3.191-3.558,3.38,3.38,0,0,0-3.536,3.365v6.756a2.8,2.8,0,0,1-3.02,2.8h-.044a2.951,2.951,0,0,1-2.976-2.955V31.294a3.5,3.5,0,0,0-3.169-3.558A3.365,3.365,0,0,0,62.086,31.1v8.115a2.87,2.87,0,0,1-3,2.8h-.065a2.857,2.857,0,0,1-3-2.8V28.3a3.492,3.492,0,0,0-3.169-3.536,3.369,3.369,0,0,0-3.536,3.365l0,10.525A3.353,3.353,0,0,1,45.779,42,3.485,3.485,0,0,1,42.6,38.458V31.218a3.359,3.359,0,0,0-6.716.1V41.8a2.8,2.8,0,0,1-3.06,2.8A2.653,2.653,0,0,1,30,41.95V31.1a3.5,3.5,0,0,0-3.169-3.558A3.369,3.369,0,0,0,23.3,30.906v6.756a2.805,2.805,0,0,1-3.02,2.8h-.04a2.951,2.951,0,0,1-2.976-2.955V32.37a3.5,3.5,0,0,0-3.191-3.558,3.38,3.38,0,0,0-3.536,3.365v5.957a2.851,2.851,0,0,1-2.976,2.8H7.471a2.845,2.845,0,0,1-2.973-2.8V32.61a3.492,3.492,0,0,0-3.169-3.536A3.461,3.461,0,0,0,.5,29.2V45.632A7.269,7.269,0,0,0,7.769,52.9Z",
    transform: "translate(0 63.896)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M18.406.5V19.1a7.269,7.269,0,0,0,7.269,7.269h18.6Z",
    transform: "translate(47.169)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M3.149,2.98H30.6v32.2H3.149Z",
    transform: "translate(6.978 6.533)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(10.127 51.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M73.5,14.447H5.824a2.675,2.675,0,1,0,0,5.35h67.67a2.675,2.675,0,1,0,0-5.35Zm0,16.928H5.824a2.675,2.675,0,0,0,0,5.35h67.67a2.675,2.675,0,1,0,0-5.35Zm0,16.928H5.824a2.675,2.675,0,0,0,0,5.35h67.67a2.675,2.675,0,0,0,0-5.35Zm0,16.925H5.824a2.675,2.675,0,0,0,0,5.35h67.67a2.675,2.675,0,1,0,0-5.35Z",
    transform: "translate(-3.149 -14.447)",
    fill: "#cacaca"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M22.916,30.378l7.512-7.512L36.3,28.735l-7.512,7.512Z",
    transform: "translate(59.05 58.918)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M52.634,40.568,35.927,23.861,23.912,35.876,40.619,52.583A8.5,8.5,0,1,0,52.634,40.567Z",
    transform: "translate(61.673 61.539)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 28.645,
    cy: 28.645,
    r: 28.645,
    transform: "translate(38.827 38.638)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 20.973,
    cy: 20.973,
    r: 20.973,
    transform: "translate(46.499 46.31)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(46.543 46.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M51.918,33.173a3.486,3.486,0,0,0,2.976,3.5,21.128,21.128,0,0,0,.178-2.6,20.841,20.841,0,0,0-3.153-11.021ZM49.341,19.7a20.935,20.935,0,0,0-36.172,13.5,3.457,3.457,0,0,0,3.125,3.325,3.365,3.365,0,0,0,3.536-3.362V25.054a2.87,2.87,0,0,1,3-2.8h.065a2.857,2.857,0,0,1,3,2.8V35.972a3.49,3.49,0,0,0,3.169,3.536A3.369,3.369,0,0,0,32.6,36.143l0-10.525a3.357,3.357,0,0,1,3.536-3.351,3.484,3.484,0,0,1,3.176,3.54V33.05a3.365,3.365,0,0,0,6.72-.1V22.467c0-1.559,1.068-2.835,3.307-2.766Z",
    transform: "translate(-13.169 -13.105)",
    fill: "#3666f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.aa3d7484d1ebc0510225da1d0baade45.svg";
export { ForwardRef as ReactComponent };